// frontend/src/router/routes/providerServiceRoutes.tsx
// Updated routes for mobile-first provider services (no modals, no bulk operations)

import { Route } from "react-router-dom";
import ProtectedRoute from "@/components/auth/ProtectedRoute";

// Import the updated pages
import ProviderServiceManagement from "@/pages/ProviderServiceManagement";
import BrowseServicesPage from "@/pages/BrowseServicesPage";
import EditServicePage from "@/pages/EditServicePage";
import RequestNewServicePage from "@/pages/RequestNewServicePage";


export const providerServiceRoutes = [
  // =====================================
  // 🔧 PROVIDER SERVICES ROUTES - MOBILE FIRST, NO MODALS
  // =====================================
  
  // Main provider services list route
  <Route
    key="provider-services"
    path="/provider-services"
    element={
      <ProtectedRoute requiredRoles={["admin", "super_admin", "provider"]}>
        <ProviderServiceManagement />
      </ProtectedRoute>
    }
  />,

  // Browse and add services page (replaces BrowseServicesModal)
  <Route
    key="provider-services-browse"
    path="/provider-services/browse"
    element={
      <ProtectedRoute requiredRoles={["admin", "super_admin", "provider"]}>
        <BrowseServicesPage />
      </ProtectedRoute>
    }
  />,

  // Edit service page (replaces EditServiceModal)
  <Route
    key="provider-services-edit"
    path="/provider-services/:id/edit"
    element={
      <ProtectedRoute requiredRoles={["admin", "super_admin", "provider"]}>
        <EditServicePage />
      </ProtectedRoute>
    }
  />,

  // Request new service page (optional - can be similar to browse but for custom requests)
  <Route
    key="provider-services-request"
    path="/provider-services/request"
    element={
      <ProtectedRoute requiredRoles={["provider"]}>
        <RequestNewServicePage />
      </ProtectedRoute>
    }
  />,

  // Legacy compatibility routes (if any exist)
  <Route
    key="services-management-legacy"
    path="/services"
    element={
      <ProtectedRoute requiredRoles={["admin", "super_admin", "provider"]}>
        <ProviderServiceManagement />
      </ProtectedRoute>
    }
  />,
];

// Export individual routes for use in main router if needed
export const providerServiceMainRoute = (
  <Route
    key="provider-services-main"
    path="/provider-services"
    element={
      <ProtectedRoute requiredRoles={["admin", "super_admin", "provider"]}>
        <ProviderServiceManagement />
      </ProtectedRoute>
    }
  />
);

export const browseServicesRoute = (
  <Route
    key="browse-services"
    path="/provider-services/browse"
    element={
      <ProtectedRoute requiredRoles={["admin", "super_admin", "provider"]}>
        <BrowseServicesPage />
      </ProtectedRoute>
    }
  />
);

export const editServiceRoute = (
  <Route
    key="edit-service"
    path="/provider-services/:id/edit"
    element={
      <ProtectedRoute requiredRoles={["admin", "super_admin", "provider"]}>
        <EditServicePage />
      </ProtectedRoute>
    }
  />
);

// NOTE: The layout (admin vs provider) is automatically determined in each page
// based on the user's role. No need to pass layout prop explicitly.